import EyeHiddenIcon from "$/lib/icons/EyeHiddenIcon";
import EyeIcon from "$/lib/icons/EyeIcon";
import { cn } from "$/lib/utils/functions/misc.functions";
import { customColors } from "tailwind.config";
import Flexbox from "../../common/Flexbox";

export type GraphFilterItemsProps = {
  name: string;
  value?: number;
  index?: number;
  isVisible?: boolean;
  color?: string;
};

type Props = {
  item: GraphFilterItemsProps;
  unit: string;
  fullWidth?: boolean;
  handleOnChange: (key: string, value: boolean) => void;
};

const COLORS = ["#5881C1", "#84BCAF", "#F8AE53", "#F2A09B"];

const GraphFilterItem = ({
  item,
  fullWidth = true,
  unit,
  handleOnChange,
}: Props) => {
  return (
    <Flexbox
      fullWidth={fullWidth}
      row
      align="center"
      justify="between"
      className={cn("gap-3 whitespace-nowrap pr-2", { "gap-2": !fullWidth })}
    >
      <Flexbox
        // fullWidth
        className={cn("gap-1", { "pointer-events-none": !item.isVisible })}
      >
        <Flexbox row align="center" justify="center" className="gap-1">
          <div
            className="h-3.5 w-3.5 rounded-[4px]"
            style={{
              backgroundColor:
                item.isVisible || typeof item.isVisible === "undefined"
                  ? (item.color ?? COLORS[item.index || 0])
                  : customColors.tertiary.DEFAULT,
            }}
          />
          <p
            className={cn("text-sm font-normal text-black", {
              "text-tertiary":
                !item.isVisible && !(typeof item.isVisible === "undefined"),
            })}
          >
            {item.name}
          </p>
        </Flexbox>

        {item.value && (
          <p
            className={cn("text-xs font-medium", {
              "text-tertiary":
                !item.isVisible && !(typeof item.isVisible === "undefined"),
            })}
            style={{
              color:
                item.isVisible || typeof item.isVisible === "undefined"
                  ? (item.color ?? COLORS[item.index || 0])
                  : customColors.tertiary.DEFAULT,
            }}
          >
            Value : {item.value} {unit}
          </p>
        )}
      </Flexbox>

      {!(typeof item.isVisible === "undefined") && (
        <button
          onClick={() => {
            handleOnChange(item.name, !item.isVisible);
          }}
        >
          {item.isVisible ? <EyeIcon /> : <EyeHiddenIcon />}
        </button>
      )}
    </Flexbox>
  );
};

export default GraphFilterItem;
